import { t } from "@lingui/macro";
import { Plus } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import { useFeatureGate } from "@/client/hooks/use-feature-gate";

import { BaseListItem } from "./base-item";

export const CreateResumeListItem = () => {
  const navigate = useNavigate();
  const { requirePlan } = useFeatureGate();

  return (
    <BaseListItem
      start={<Plus size={18} />}
      onClick={() => {
        if (!requirePlan(t`Subscribe to a plan to start creating resumes.`)) return;
        navigate("/onboarding?new=1");
      }}
      title={t`Build a resume`}
      description={t`Tell us what you've done, or start blank`}
    />
  );
};
